export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  CustomDecimal: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  GenericScalar: { input: any; output: any; }
  Upload: { input: any; output: any; }
}

/** This node provides information of users. */
export interface AccountNode extends Node {
  __typename?: 'AccountNode';
  activeOrdersCount?: Maybe<Scalars['Int']['output']>;
  checkedIn?: Maybe<Scalars['Boolean']['output']>;
  client?: Maybe<ClientNode>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  groups?: Maybe<Array<Maybe<GroupNode>>>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** Legt fest, ob dieser Benutzer aktiv ist. Kann deaktiviert werden, anstatt Benutzer zu löschen. */
  isActive: Scalars['Boolean']['output'];
  isStaff: Scalars['Boolean']['output'];
  isSuperuser: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  permissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
}

export interface AccountNodeConnection {
  __typename?: 'AccountNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AccountNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
}

/** A Relay edge containing a `AccountNode` and its cursor. */
export interface AccountNodeEdge {
  __typename?: 'AccountNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AccountNode>;
}

/** An enumeration. */
export enum AmountUnitChoice {
  Atr = 'ATR',
  Cbm = 'CBM',
  Cft = 'CFT',
  Fmo = 'FMO',
  Lfm = 'LFM',
  Lut = 'LUT',
  Rmm = 'RMM',
  Srm = 'SRM',
  Stk = 'STK'
}

export interface AppendPilesToExistingOrderMutation {
  __typename?: 'AppendPilesToExistingOrderMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
}

/** An enumeration. */
export enum CategoryTypeChoice {
  Purchase = 'PURCHASE',
  Transport = 'TRANSPORT'
}

export interface ChangeCompanyMutation {
  __typename?: 'ChangeCompanyMutation';
  company?: Maybe<CompanyNode>;
  ok?: Maybe<Scalars['Boolean']['output']>;
}

/**
 * A mutation that allows a logged in user to change his/her password by providing the old password.
 *
 * Make sure to query for the ok field as well as the errors to see if changing the password was successful. For
 * example:
 *
 * ```
 * mutation {
 *   changePassword(newPassword1: "<new-pw>", newPassword2: "<new-pw>", oldPassword: "<old-pw>") {
 *     ok
 *     errors {
 *       field
 *       messages {
 *         code
 *         message
 *       }
 *     }
 *   }
 * }
 * ```
 */
export interface ChangePasswordMutation {
  __typename?: 'ChangePasswordMutation';
  /** A list of errors in case ok is false. */
  errors?: Maybe<Array<Maybe<FieldErrorType>>>;
  /** Indicates whether changing the password was successful or not. */
  ok?: Maybe<Scalars['Boolean']['output']>;
}

export interface ChangePileMutation {
  __typename?: 'ChangePileMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
  pile?: Maybe<PileNode>;
}

export interface ChangePlotMutation {
  __typename?: 'ChangePlotMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
  plot?: Maybe<PlotNode>;
}

export interface ChangeToNextStatus {
  __typename?: 'ChangeToNextStatus';
  ok?: Maybe<Scalars['Boolean']['output']>;
}

/** A mutation that users can use to check in and create a Timesheet. */
export interface CheckInMutation {
  __typename?: 'CheckInMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
}

/** A mutation that users can use to end the current Timesheet and check out. */
export interface CheckOutMutation {
  __typename?: 'CheckOutMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
}

/** This node provides information of clients. */
export interface ClientNode extends Node {
  __typename?: 'ClientNode';
  /** Können Nutzer Polter erstellen und bearbeiten? */
  canChangePlotPile: Scalars['Boolean']['output'];
  /** Können Nutzer Polter exportieren? */
  canExportPiles: Scalars['Boolean']['output'];
  /** Können Nutzer die Zeiterfassung in der Applikation nutzen, die dem Client zugeordnet sind? */
  canUseTimeRecording: Scalars['Boolean']['output'];
  graphhopperApiKey?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tileServerUrl?: Maybe<Scalars['String']['output']>;
}

/** An enumeration. */
export enum CompanyLocationCountry {
  /** Andorra */
  Ad = 'AD',
  /** Vereinigte Arabische Emirate */
  Ae = 'AE',
  /** Afghanistan */
  Af = 'AF',
  /** Antigua und Barbuda */
  Ag = 'AG',
  /** Anguilla */
  Ai = 'AI',
  /** Albanien */
  Al = 'AL',
  /** Armenien */
  Am = 'AM',
  /** Angola */
  Ao = 'AO',
  /** Antarktis */
  Aq = 'AQ',
  /** Argentinien */
  Ar = 'AR',
  /** Amerikanisch-Samoa */
  As = 'AS',
  /** Österreich */
  At = 'AT',
  /** Australien */
  Au = 'AU',
  /** Aruba */
  Aw = 'AW',
  /** Åland-Inseln */
  Ax = 'AX',
  /** Aserbaidschan */
  Az = 'AZ',
  /** Bosnien und Herzegowina */
  Ba = 'BA',
  /** Barbados */
  Bb = 'BB',
  /** Bangladesch */
  Bd = 'BD',
  /** Belgien */
  Be = 'BE',
  /** Burkina Faso */
  Bf = 'BF',
  /** Bulgarien */
  Bg = 'BG',
  /** Bahrain */
  Bh = 'BH',
  /** Burundi */
  Bi = 'BI',
  /** Benin */
  Bj = 'BJ',
  /** Saint-Barthélemy */
  Bl = 'BL',
  /** Bermuda */
  Bm = 'BM',
  /** Brunei */
  Bn = 'BN',
  /** Bolivien */
  Bo = 'BO',
  /** Bonaire, Sint Eustatius und Saba */
  Bq = 'BQ',
  /** Brasilien */
  Br = 'BR',
  /** Bahamas */
  Bs = 'BS',
  /** Bhutan */
  Bt = 'BT',
  /** Bouvetinsel */
  Bv = 'BV',
  /** Botswana */
  Bw = 'BW',
  /** Belarus */
  By = 'BY',
  /** Belize */
  Bz = 'BZ',
  /** Kanada */
  Ca = 'CA',
  /** Kokosinseln (Keelinginseln) */
  Cc = 'CC',
  /** Kongo (Demokratische Republik) */
  Cd = 'CD',
  /** Zentralafrikanische Republik */
  Cf = 'CF',
  /** Kongo */
  Cg = 'CG',
  /** Schweiz */
  Ch = 'CH',
  /** Côte d'Ivoire */
  Ci = 'CI',
  /** Cookinseln */
  Ck = 'CK',
  /** Chile */
  Cl = 'CL',
  /** Kamerun */
  Cm = 'CM',
  /** China */
  Cn = 'CN',
  /** Kolumbien */
  Co = 'CO',
  /** Costa Rica */
  Cr = 'CR',
  /** Kuba */
  Cu = 'CU',
  /** Kap Verde */
  Cv = 'CV',
  /** Curaçao */
  Cw = 'CW',
  /** Weihnachtsinsel */
  Cx = 'CX',
  /** Zypern */
  Cy = 'CY',
  /** Tschechien */
  Cz = 'CZ',
  /** Deutschland */
  De = 'DE',
  /** Dschibuti */
  Dj = 'DJ',
  /** Dänemark */
  Dk = 'DK',
  /** Dominica */
  Dm = 'DM',
  /** Dominikanische Republik */
  Do = 'DO',
  /** Algerien */
  Dz = 'DZ',
  /** Ecuador */
  Ec = 'EC',
  /** Estland */
  Ee = 'EE',
  /** Ägypten */
  Eg = 'EG',
  /** Westsahara */
  Eh = 'EH',
  /** Eritrea */
  Er = 'ER',
  /** Spanien */
  Es = 'ES',
  /** Äthiopien */
  Et = 'ET',
  /** Finnland */
  Fi = 'FI',
  /** Fidschi */
  Fj = 'FJ',
  /** Falklandinseln (Malwinen) */
  Fk = 'FK',
  /** Mikronesien (Föderierte Staaten von) */
  Fm = 'FM',
  /** Faröerinseln */
  Fo = 'FO',
  /** Frankreich */
  Fr = 'FR',
  /** Gabun */
  Ga = 'GA',
  /** Vereinigtes Königreich */
  Gb = 'GB',
  /** Granada */
  Gd = 'GD',
  /** Georgien */
  Ge = 'GE',
  /** Französisch-Guayana */
  Gf = 'GF',
  /** Guernsey */
  Gg = 'GG',
  /** Ghana */
  Gh = 'GH',
  /** Gibraltar */
  Gi = 'GI',
  /** Grönland */
  Gl = 'GL',
  /** Gambia */
  Gm = 'GM',
  /** Guinea */
  Gn = 'GN',
  /** Guadeloupe */
  Gp = 'GP',
  /** Äquatorialguinea */
  Gq = 'GQ',
  /** Griechenland */
  Gr = 'GR',
  /** Südgeorgien und die Südlichen Sandwichinseln */
  Gs = 'GS',
  /** Guatemala */
  Gt = 'GT',
  /** Guam */
  Gu = 'GU',
  /** Guinea-Bissau */
  Gw = 'GW',
  /** Guyana */
  Gy = 'GY',
  /** Hong Kong */
  Hk = 'HK',
  /** Heard und McDonaldinseln */
  Hm = 'HM',
  /** Honduras */
  Hn = 'HN',
  /** Kroatien */
  Hr = 'HR',
  /** Haiti */
  Ht = 'HT',
  /** Ungarn */
  Hu = 'HU',
  /** Indonesien */
  Id = 'ID',
  /** Irland */
  Ie = 'IE',
  /** Israel */
  Il = 'IL',
  /** Isle of Man */
  Im = 'IM',
  /** Indien */
  In = 'IN',
  /** Britisches Territorium im Indischen Ozean */
  Io = 'IO',
  /** Irak */
  Iq = 'IQ',
  /** Iran */
  Ir = 'IR',
  /** Island */
  Is = 'IS',
  /** Italien */
  It = 'IT',
  /** Jersey */
  Je = 'JE',
  /** Jamaika */
  Jm = 'JM',
  /** Jordanien */
  Jo = 'JO',
  /** Japan */
  Jp = 'JP',
  /** Kenia */
  Ke = 'KE',
  /** Kirgisistan */
  Kg = 'KG',
  /** Kambodscha */
  Kh = 'KH',
  /** Kirivati */
  Ki = 'KI',
  /** Komoren */
  Km = 'KM',
  /** St. Kitts und Nevis */
  Kn = 'KN',
  /** Nordkorea */
  Kp = 'KP',
  /** Südkorea */
  Kr = 'KR',
  /** Kuwait */
  Kw = 'KW',
  /** Kaimaninseln */
  Ky = 'KY',
  /** Kasachstan */
  Kz = 'KZ',
  /** Laos */
  La = 'LA',
  /** Libanon */
  Lb = 'LB',
  /** St. Lucia */
  Lc = 'LC',
  /** Liechtenstein */
  Li = 'LI',
  /** Sri Lanka */
  Lk = 'LK',
  /** Liberia */
  Lr = 'LR',
  /** Lesotho */
  Ls = 'LS',
  /** Litauen */
  Lt = 'LT',
  /** Luxemburg */
  Lu = 'LU',
  /** Lettland */
  Lv = 'LV',
  /** Libyen */
  Ly = 'LY',
  /** Marokko */
  Ma = 'MA',
  /** Monaco */
  Mc = 'MC',
  /** Moldawien */
  Md = 'MD',
  /** Montenegro */
  Me = 'ME',
  /** St. Martin (französischer Teil) */
  Mf = 'MF',
  /** Madagaskar */
  Mg = 'MG',
  /** Marshallinseln */
  Mh = 'MH',
  /** Nordmazedonien */
  Mk = 'MK',
  /** Mali */
  Ml = 'ML',
  /** Myanmar */
  Mm = 'MM',
  /** Mongolei */
  Mn = 'MN',
  /** Macau */
  Mo = 'MO',
  /** Commonwealth der Nördlichen Marianen */
  Mp = 'MP',
  /** Martinique */
  Mq = 'MQ',
  /** Mauretanien */
  Mr = 'MR',
  /** Montserrat */
  Ms = 'MS',
  /** Malta */
  Mt = 'MT',
  /** Mauritius */
  Mu = 'MU',
  /** Malediven */
  Mv = 'MV',
  /** Malawi */
  Mw = 'MW',
  /** Mexiko */
  Mx = 'MX',
  /** Malaysia */
  My = 'MY',
  /** Mozambique */
  Mz = 'MZ',
  /** Namibia */
  Na = 'NA',
  /** Neukaledonien */
  Nc = 'NC',
  /** Niger */
  Ne = 'NE',
  /** Norfolkinsel */
  Nf = 'NF',
  /** Nigeria */
  Ng = 'NG',
  /** Nicaragua */
  Ni = 'NI',
  /** Niederlande */
  Nl = 'NL',
  /** Norwegen */
  No = 'NO',
  /** Nepal */
  Np = 'NP',
  /** Nauru */
  Nr = 'NR',
  /** Niue */
  Nu = 'NU',
  /** Neuseeland */
  Nz = 'NZ',
  /** Oman */
  Om = 'OM',
  /** Panama */
  Pa = 'PA',
  /** Peru */
  Pe = 'PE',
  /** Französisch-Polynesien */
  Pf = 'PF',
  /** Papua Neu Guinea */
  Pg = 'PG',
  /** Philippinen */
  Ph = 'PH',
  /** Pakistan */
  Pk = 'PK',
  /** Polen */
  Pl = 'PL',
  /** Saint-Pierre und Miquelon */
  Pm = 'PM',
  /** Pitcairn */
  Pn = 'PN',
  /** Puerto Rico */
  Pr = 'PR',
  /** Palästina */
  Ps = 'PS',
  /** Portugal */
  Pt = 'PT',
  /** Palau */
  Pw = 'PW',
  /** Paraguay */
  Py = 'PY',
  /** Katar */
  Qa = 'QA',
  /** Réunion */
  Re = 'RE',
  /** Rumänien */
  Ro = 'RO',
  /** Serbien */
  Rs = 'RS',
  /** Russland */
  Ru = 'RU',
  /** Ruanda */
  Rw = 'RW',
  /** Saudi Arabien */
  Sa = 'SA',
  /** Salomonen */
  Sb = 'SB',
  /** Seychellen */
  Sc = 'SC',
  /** Sudan */
  Sd = 'SD',
  /** Schweden */
  Se = 'SE',
  /** Singapur */
  Sg = 'SG',
  /** St. Helena, Ascension und Tristan da Cunha */
  Sh = 'SH',
  /** Slowenien */
  Si = 'SI',
  /** Spitzbergen und Jan Mayen */
  Sj = 'SJ',
  /** Slowakei */
  Sk = 'SK',
  /** Sierra Leone */
  Sl = 'SL',
  /** San Marino */
  Sm = 'SM',
  /** Senegal */
  Sn = 'SN',
  /** Somalia */
  So = 'SO',
  /** Surinam */
  Sr = 'SR',
  /** Südsudan */
  Ss = 'SS',
  /** São Tomé und Príncipe */
  St = 'ST',
  /** El Salvador */
  Sv = 'SV',
  /** Sint Maarten (niederländischer Teil) */
  Sx = 'SX',
  /** Syrien */
  Sy = 'SY',
  /** Swasiland */
  Sz = 'SZ',
  /** Turks- und Caicosinseln */
  Tc = 'TC',
  /** Tschad */
  Td = 'TD',
  /** Französische Süd- und Antarktisgebiete */
  Tf = 'TF',
  /** Togo */
  Tg = 'TG',
  /** Thailand */
  Th = 'TH',
  /** Tadschikistan */
  Tj = 'TJ',
  /** Tokelau */
  Tk = 'TK',
  /** Osttimor */
  Tl = 'TL',
  /** Turkmenistan */
  Tm = 'TM',
  /** Tunesien */
  Tn = 'TN',
  /** Tonga */
  To = 'TO',
  /** Türkei */
  Tr = 'TR',
  /** Trinidad und Tobago */
  Tt = 'TT',
  /** Tuvalu */
  Tv = 'TV',
  /** Taiwan */
  Tw = 'TW',
  /** Tansania */
  Tz = 'TZ',
  /** Ukraine */
  Ua = 'UA',
  /** Uganda */
  Ug = 'UG',
  /** USA - Sonstige Kleine Inseln */
  Um = 'UM',
  /** Vereinigte Staaten von Amerika */
  Us = 'US',
  /** Uruguay */
  Uy = 'UY',
  /** Usbekistan */
  Uz = 'UZ',
  /** Vatikanstadt */
  Va = 'VA',
  /** St. Vincent und die Grenadinen */
  Vc = 'VC',
  /** Venezuela */
  Ve = 'VE',
  /** Britische Jungferninseln */
  Vg = 'VG',
  /** Amerikanische Jungferninseln */
  Vi = 'VI',
  /** Vietnam */
  Vn = 'VN',
  /** Vanuatu */
  Vu = 'VU',
  /** Wallis und Futuna */
  Wf = 'WF',
  /** Samoa */
  Ws = 'WS',
  /** Jemen */
  Ye = 'YE',
  /** Mayotte */
  Yt = 'YT',
  /** Südafrika */
  Za = 'ZA',
  /** Sambia */
  Zm = 'ZM',
  /** Simbabwe */
  Zw = 'ZW'
}

/** This node provides information of delivery addresses. */
export interface CompanyLocationNode extends Node {
  __typename?: 'CompanyLocationNode';
  country: CompanyLocationCountry;
  housenumber?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  partOfVillage?: Maybe<Scalars['String']['output']>;
  postcode: Scalars['String']['output'];
  street: Scalars['String']['output'];
}

export interface CompanyLocationNodeConnection {
  __typename?: 'CompanyLocationNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CompanyLocationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
}

/** A Relay edge containing a `CompanyLocationNode` and its cursor. */
export interface CompanyLocationNodeEdge {
  __typename?: 'CompanyLocationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CompanyLocationNode>;
}

/** This node provides information of companies. */
export interface CompanyNode extends Node {
  __typename?: 'CompanyNode';
  billingAddress?: Maybe<CompanyLocationNode>;
  carrier: Scalars['Boolean']['output'];
  customer: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  info?: Maybe<Scalars['String']['output']>;
  matchcode?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  pkOtherSystem?: Maybe<Scalars['String']['output']>;
  supplier: Scalars['Boolean']['output'];
}

export interface CompanyNodeConnection {
  __typename?: 'CompanyNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CompanyNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
}

/** A Relay edge containing a `CompanyNode` and its cursor. */
export interface CompanyNodeEdge {
  __typename?: 'CompanyNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CompanyNode>;
}

export interface CreateAccountMutation {
  __typename?: 'CreateAccountMutation';
  account?: Maybe<AccountNode>;
  ok?: Maybe<Scalars['Boolean']['output']>;
}

export interface CreateCompanyMutation {
  __typename?: 'CreateCompanyMutation';
  company?: Maybe<CompanyNode>;
  ok?: Maybe<Scalars['Boolean']['output']>;
}

export interface CreateInventoryMutation {
  __typename?: 'CreateInventoryMutation';
  inventory?: Maybe<InventoryNode>;
}

export interface CreateOrderMutation {
  __typename?: 'CreateOrderMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<OrderNode>;
}

export interface CreatePileMutation {
  __typename?: 'CreatePileMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
  pile?: Maybe<PileNode>;
}

export interface CreatePlotMutation {
  __typename?: 'CreatePlotMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
  plot?: Maybe<PlotNode>;
}

export interface CreateWagonInventoryMutation {
  __typename?: 'CreateWagonInventoryMutation';
  inventories?: Maybe<Array<Maybe<InventoryNode>>>;
}

/** Obtain JSON Web Token mutation */
export interface CustomObtainJsonWebToken {
  __typename?: 'CustomObtainJSONWebToken';
  token: Scalars['String']['output'];
}

export interface DeleteInventoryMutation {
  __typename?: 'DeleteInventoryMutation';
  inventory?: Maybe<InventoryNode>;
  ok?: Maybe<Scalars['Boolean']['output']>;
}

export interface DeletePileMutation {
  __typename?: 'DeletePileMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
}

export interface DeletePilesFromExistingOrderMutation {
  __typename?: 'DeletePilesFromExistingOrderMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
}

export interface DeletePilesListMutation {
  __typename?: 'DeletePilesListMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
}

export interface DeletePlotMutation {
  __typename?: 'DeletePlotMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
}

export interface DeleteTimeSheetMutation {
  __typename?: 'DeleteTimeSheetMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
  timesheet?: Maybe<TimeSheetNode>;
}

export interface DeprecatedDeliveryStatus {
  __typename?: 'DeprecatedDeliveryStatus';
  /** @deprecated Will be removed */
  id?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Will be removed */
  number?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Will be removed */
  shortDescription?: Maybe<Scalars['String']['output']>;
}

export interface DownloadPileMutation {
  __typename?: 'DownloadPileMutation';
  ok?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
}

export interface DownloadWagonInventoryMutation {
  __typename?: 'DownloadWagonInventoryMutation';
  ok?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
}

export interface EditAccountMutation {
  __typename?: 'EditAccountMutation';
  account?: Maybe<AccountNode>;
  ok?: Maybe<Scalars['Boolean']['output']>;
}

export interface EditInventoryMutation {
  __typename?: 'EditInventoryMutation';
  inventory?: Maybe<InventoryNode>;
}

export interface EditInventoryTimeMutation {
  __typename?: 'EditInventoryTimeMutation';
  inventory?: Maybe<InventoryNode>;
  ok?: Maybe<Scalars['Boolean']['output']>;
}

export interface EditOrderDeliveryWeightFormNumberMutation {
  __typename?: 'EditOrderDeliveryWeightFormNumberMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<OrderNode>;
}

export interface EditOrderIsPlausibleMutation {
  __typename?: 'EditOrderIsPlausibleMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<OrderNode>;
}

/**
 * A mutation that allows to update an instance of :py:class:`apps.order.models.Order`.
 *
 * This update mutation is idempotent with regard to the fields: customer, supplier, vehicle, driver, transport_media,
 * plan_date, repeat, and note. Therefore, even if one of these fields is not to change, its old value needs
 * to be provided, otherwise its value will be reset to the default value. In that regard it behaves similar to a HTTP
 * PUT method.
 *
 * Requires the ``order.change_order`` permission on the executing user.
 *
 * An example mutation can be found below:
 *
 * ```
 * mutation {
 *   editOrder(
 *     order: "<global id of the order to be edited>",
 *     customer: "<global id of a customer>",
 *     supplier: "<global id of a supplier>",
 *     vehicle: "<global id of a vehicle>",
 *     planDate: "<date in ISO-8601>",
 *     driver: "<global id of a driver>",
 *     repeat: <boolean>,
 *     transportMedia: "<global id of a file>",
 *     note: "<note text>",
 *     deliveryNumber: "<delivery number as string>",
 *     weightFormNumber: <weight form number as string>"
 *   ) {
 *     ok
 *     order {
 *       id
 *     }
 *   }
 * }
 * ```
 */
export interface EditOrderMutation {
  __typename?: 'EditOrderMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<OrderNode>;
}

/** A mutation that users can use edit a Timesheet. */
export interface EditTimeSheetMutation {
  __typename?: 'EditTimeSheetMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
}

/**
 * A type that represents a specific field error message with a message and code.
 *
 * >>> FieldErrorMessageType(
 * >>>     message=_('Password is wrong'),
 * >>>     code='wrong_password'
 * >>> )
 */
export interface FieldErrorMessageType {
  __typename?: 'FieldErrorMessageType';
  /** A code that represents the error message. */
  code?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
}

/**
 * A type that represents errors of an input field.
 *
 * For example, if a field "password" has a wrong value, the error can be indicated with:
 * >>> FieldErrorType(field='password', messages=[
 * >>>     FieldErrorMessageType(
 * >>>         message=_('Password is wrong'),
 * >>>         code='wrong_password'
 * >>>     )
 * >>> ])
 */
export interface FieldErrorType {
  __typename?: 'FieldErrorType';
  /** The name of the form field. */
  field?: Maybe<Scalars['String']['output']>;
  /** A list of FieldErrorMessageTypes */
  messages?: Maybe<Array<Maybe<FieldErrorMessageType>>>;
}

/** This node provides information of file uploads. */
export interface FileUploadNode extends Node {
  __typename?: 'FileUploadNode';
  file: Scalars['String']['output'];
  hashSum: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  s3Path?: Maybe<Scalars['String']['output']>;
}

/** This node provides information of users */
export interface GroupNode extends Node {
  __typename?: 'GroupNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
}

export interface GroupNodeConnection {
  __typename?: 'GroupNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GroupNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
}

/** A Relay edge containing a `GroupNode` and its cursor. */
export interface GroupNodeEdge {
  __typename?: 'GroupNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<GroupNode>;
}

/** This node provides information of inventories by delivery status. */
export interface InventoriesByDeliveryStatusNode {
  __typename?: 'InventoriesByDeliveryStatusNode';
  allAmount?: Maybe<Scalars['Float']['output']>;
  allCount?: Maybe<Scalars['Float']['output']>;
  isWagonReady?: Maybe<Scalars['Boolean']['output']>;
  orderId?: Maybe<Scalars['ID']['output']>;
  orderNumber?: Maybe<Scalars['Int']['output']>;
  plotNumber?: Maybe<Scalars['Int']['output']>;
  salesNumber?: Maybe<Scalars['String']['output']>;
  wagonNumber?: Maybe<Scalars['Int']['output']>;
}

export interface InventoryDetailNode extends Node {
  __typename?: 'InventoryDetailNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  stackHeight: Scalars['Decimal']['output'];
  stackNumber: Scalars['Decimal']['output'];
  stackWidth: Scalars['Decimal']['output'];
  woodLength: Scalars['Decimal']['output'];
}

export interface InventoryDetailType {
  stackHeight?: InputMaybe<Scalars['Float']['input']>;
  stackNumber?: InputMaybe<Scalars['Int']['input']>;
  stackWidth?: InputMaybe<Scalars['Float']['input']>;
  woodLength?: InputMaybe<Scalars['Float']['input']>;
}

/** This node provides information of Inventory. */
export interface InventoryNode extends Node {
  __typename?: 'InventoryNode';
  accuracy?: Maybe<Scalars['Decimal']['output']>;
  amount: Scalars['Decimal']['output'];
  count: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<AccountNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inventoryDetails?: Maybe<Array<Maybe<InventoryDetailNode>>>;
  isBroached: Scalars['Boolean']['output'];
  isCalculated?: Maybe<Scalars['Boolean']['output']>;
  isMutable?: Maybe<Scalars['Boolean']['output']>;
  isWagonReady?: Maybe<Scalars['Boolean']['output']>;
  lastmodifiedBy?: Maybe<AccountNode>;
  latitude?: Maybe<Scalars['Decimal']['output']>;
  longitude?: Maybe<Scalars['Decimal']['output']>;
  order?: Maybe<OrderNode>;
  pile?: Maybe<PileNode>;
  rest?: Maybe<Scalars['Int']['output']>;
  time: Scalars['DateTime']['output'];
  wagonNumber?: Maybe<Scalars['Int']['output']>;
}

export interface InventoryNodeConnection {
  __typename?: 'InventoryNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InventoryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
}

/** A Relay edge containing a `InventoryNode` and its cursor. */
export interface InventoryNodeEdge {
  __typename?: 'InventoryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<InventoryNode>;
}

/** This node provides information about InventoryPlaning */
export interface InventoryPlaningNode extends Node {
  __typename?: 'InventoryPlaningNode';
  amount: Scalars['Decimal']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  order: OrderStatusNode;
  pile: PileNode;
}

export interface InventoryPlaningNodeConnection {
  __typename?: 'InventoryPlaningNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InventoryPlaningNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
}

/** A Relay edge containing a `InventoryPlaningNode` and its cursor. */
export interface InventoryPlaningNodeEdge {
  __typename?: 'InventoryPlaningNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<InventoryPlaningNode>;
}

/** This node provides a summary of all inventories in an order. */
export interface InventorySummaryNode {
  __typename?: 'InventorySummaryNode';
  combinedHeight?: Maybe<Scalars['Float']['output']>;
  stackNumber?: Maybe<Scalars['Int']['output']>;
  stackWidth?: Maybe<Scalars['Float']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  woodLength?: Maybe<Scalars['Float']['output']>;
}

/** An enumeration. */
export enum LocationTypeChoice {
  Factory = 'FACTORY',
  Forest = 'FOREST',
  Harbor = 'HARBOR',
  Pile = 'PILE',
  Ship = 'SHIP',
  Station = 'STATION',
  Wagon = 'WAGON'
}

/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface Mutation {
  __typename?: 'Mutation';
  appendPilesToExistingOrder?: Maybe<AppendPilesToExistingOrderMutation>;
  changeCompany?: Maybe<ChangeCompanyMutation>;
  /**
   * A mutation that allows a logged in user to change his/her password by providing the old password.
   *
   * Make sure to query for the ok field as well as the errors to see if changing the password was successful. For
   * example:
   *
   * ```
   * mutation {
   *   changePassword(newPassword1: "<new-pw>", newPassword2: "<new-pw>", oldPassword: "<old-pw>") {
   *     ok
   *     errors {
   *       field
   *       messages {
   *         code
   *         message
   *       }
   *     }
   *   }
   * }
   * ```
   */
  changePassword?: Maybe<ChangePasswordMutation>;
  changePile?: Maybe<ChangePileMutation>;
  changePlot?: Maybe<ChangePlotMutation>;
  changeRoute?: Maybe<RouteMutation>;
  changeToNextStatus?: Maybe<ChangeToNextStatus>;
  /** A mutation that users can use to check in and create a Timesheet. */
  checkIn?: Maybe<CheckInMutation>;
  /** A mutation that users can use to end the current Timesheet and check out. */
  checkOut?: Maybe<CheckOutMutation>;
  createAccount?: Maybe<CreateAccountMutation>;
  createCompany?: Maybe<CreateCompanyMutation>;
  createInventory?: Maybe<CreateInventoryMutation>;
  createOrder?: Maybe<CreateOrderMutation>;
  createPile?: Maybe<CreatePileMutation>;
  createPlot?: Maybe<CreatePlotMutation>;
  createWagonInventory?: Maybe<CreateWagonInventoryMutation>;
  deleteInventory?: Maybe<DeleteInventoryMutation>;
  deletePile?: Maybe<DeletePileMutation>;
  deletePilesFromExistingOrder?: Maybe<DeletePilesFromExistingOrderMutation>;
  deletePilesList?: Maybe<DeletePilesListMutation>;
  deletePlot?: Maybe<DeletePlotMutation>;
  deleteTimesheet?: Maybe<DeleteTimeSheetMutation>;
  downloadWagonInventory?: Maybe<DownloadWagonInventoryMutation>;
  editAccount?: Maybe<EditAccountMutation>;
  editInventory?: Maybe<EditInventoryMutation>;
  editInventoryTime?: Maybe<EditInventoryTimeMutation>;
  /**
   * A mutation that allows to update an instance of :py:class:`apps.order.models.Order`.
   *
   * This update mutation is idempotent with regard to the fields: customer, supplier, vehicle, driver, transport_media,
   * plan_date, repeat, and note. Therefore, even if one of these fields is not to change, its old value needs
   * to be provided, otherwise its value will be reset to the default value. In that regard it behaves similar to a HTTP
   * PUT method.
   *
   * Requires the ``order.change_order`` permission on the executing user.
   *
   * An example mutation can be found below:
   *
   * ```
   * mutation {
   *   editOrder(
   *     order: "<global id of the order to be edited>",
   *     customer: "<global id of a customer>",
   *     supplier: "<global id of a supplier>",
   *     vehicle: "<global id of a vehicle>",
   *     planDate: "<date in ISO-8601>",
   *     driver: "<global id of a driver>",
   *     repeat: <boolean>,
   *     transportMedia: "<global id of a file>",
   *     note: "<note text>",
   *     deliveryNumber: "<delivery number as string>",
   *     weightFormNumber: <weight form number as string>"
   *   ) {
   *     ok
   *     order {
   *       id
   *     }
   *   }
   * }
   * ```
   */
  editOrder?: Maybe<EditOrderMutation>;
  editOrderDeliveryWeightFormNumber?: Maybe<EditOrderDeliveryWeightFormNumberMutation>;
  editOrderIsPlausible?: Maybe<EditOrderIsPlausibleMutation>;
  /** A mutation that users can use edit a Timesheet. */
  editTimesheet?: Maybe<EditTimeSheetMutation>;
  exportPiles?: Maybe<DownloadPileMutation>;
  importPiles?: Maybe<UploadPilesMutation>;
  refreshToken?: Maybe<Refresh>;
  rollbackOrderStatusChange?: Maybe<RollbackOrderStatusChange>;
  setDeliveryNoteCustomer?: Maybe<OrderDeliveryNoteCustomerMutation>;
  setDeliveryNoteSupplier?: Maybe<OrderDeliveryNoteSupplierMutation>;
  setOrderStatus?: Maybe<OrderStatusMutation>;
  /** Obtain JSON Web Token mutation */
  tokenAuth?: Maybe<CustomObtainJsonWebToken>;
  updateMilageOnStatusChange?: Maybe<UpdateMilageOnStatusChange>;
  verifyToken?: Maybe<Verify>;
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationAppendPilesToExistingOrderArgs {
  orderId: Scalars['ID']['input'];
  pileIdList: Array<InputMaybe<Scalars['ID']['input']>>;
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationChangeCompanyArgs {
  billingAddressCountry?: InputMaybe<Scalars['String']['input']>;
  billingAddressHousenumber?: InputMaybe<Scalars['String']['input']>;
  billingAddressPartOfVillage?: InputMaybe<Scalars['String']['input']>;
  billingAddressPostcode: Scalars['String']['input'];
  billingAddressStreet?: InputMaybe<Scalars['String']['input']>;
  carrier?: InputMaybe<Scalars['Boolean']['input']>;
  companyId: Scalars['ID']['input'];
  customer?: InputMaybe<Scalars['Boolean']['input']>;
  information?: InputMaybe<Scalars['String']['input']>;
  matchcode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['Boolean']['input']>;
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationChangePasswordArgs {
  newPassword1: Scalars['String']['input'];
  newPassword2: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationChangePileArgs {
  amountUnit: AmountUnitChoice;
  category?: InputMaybe<Scalars['String']['input']>;
  cbkNet: Scalars['CustomDecimal']['input'];
  cbkSolid: Scalars['CustomDecimal']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  factorCbkNetCbkSolid?: InputMaybe<Scalars['CustomDecimal']['input']>;
  latitude: Scalars['CustomDecimal']['input'];
  location: Scalars['String']['input'];
  locationPlan?: InputMaybe<Scalars['String']['input']>;
  locationType: LocationTypeChoice;
  logLength: Scalars['CustomDecimal']['input'];
  longitude: Scalars['CustomDecimal']['input'];
  markedAsBroached?: InputMaybe<Scalars['Boolean']['input']>;
  mustBeAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  pileId: Scalars['ID']['input'];
  pileNumberFurnisher?: InputMaybe<Scalars['String']['input']>;
  plotNumber: Scalars['Int']['input'];
  qualityType: QualityTypeChoice;
  sort: Scalars['String']['input'];
  status: OldSystemStatusChoice;
  timber?: InputMaybe<Scalars['String']['input']>;
  type: PileTypeChoice;
  usageSort: UsageSortChoice;
  woodtype: Scalars['String']['input'];
  woodtype2?: InputMaybe<Scalars['String']['input']>;
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationChangePlotArgs {
  category: CategoryTypeChoice;
  customer?: InputMaybe<Scalars['ID']['input']>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  mustBeRemovedSeparately?: InputMaybe<Scalars['Boolean']['input']>;
  number: Scalars['Int']['input'];
  plotId: Scalars['ID']['input'];
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationChangeRouteArgs {
  orderId: Scalars['ID']['input'];
  routes?: InputMaybe<Array<InputMaybe<RouteNodeInput>>>;
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationChangeToNextStatusArgs {
  orderId: Scalars['ID']['input'];
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationCheckInArgs {
  checkInDispatchedAt: Scalars['DateTime']['input'];
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationCheckOutArgs {
  checkOutDispatchedAt: Scalars['DateTime']['input'];
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationCreateAccountArgs {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordRepeat: Scalars['String']['input'];
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationCreateCompanyArgs {
  billingAddressCountry?: InputMaybe<Scalars['String']['input']>;
  billingAddressHousenumber?: InputMaybe<Scalars['String']['input']>;
  billingAddressPartOfVillage?: InputMaybe<Scalars['String']['input']>;
  billingAddressPostcode: Scalars['String']['input'];
  billingAddressStreet?: InputMaybe<Scalars['String']['input']>;
  carrier?: InputMaybe<Scalars['Boolean']['input']>;
  customer?: InputMaybe<Scalars['Boolean']['input']>;
  information?: InputMaybe<Scalars['String']['input']>;
  matchcode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['Boolean']['input']>;
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationCreateInventoryArgs {
  accuracy?: InputMaybe<Scalars['Decimal']['input']>;
  amount: Scalars['Float']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
  inventoryDetails?: InputMaybe<Array<InputMaybe<InventoryDetailType>>>;
  isBroached: Scalars['Boolean']['input'];
  latitude?: InputMaybe<Scalars['Decimal']['input']>;
  longitude?: InputMaybe<Scalars['Decimal']['input']>;
  order: Scalars['ID']['input'];
  pile: Scalars['ID']['input'];
  rest?: InputMaybe<Scalars['Int']['input']>;
  time: Scalars['String']['input'];
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationCreateOrderArgs {
  amount?: InputMaybe<Scalars['Int']['input']>;
  customer: Scalars['ID']['input'];
  deliveryStatus?: InputMaybe<Scalars['ID']['input']>;
  driver?: InputMaybe<Scalars['ID']['input']>;
  isPlausible?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  noteDriver?: InputMaybe<Scalars['String']['input']>;
  piles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  planDate?: InputMaybe<Scalars['DateTime']['input']>;
  repeat?: InputMaybe<Scalars['Boolean']['input']>;
  repeatEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  routes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  supplier?: InputMaybe<Scalars['ID']['input']>;
  transportMedia?: InputMaybe<Scalars['ID']['input']>;
  vehicle?: InputMaybe<Scalars['ID']['input']>;
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationCreatePileArgs {
  amountUnit: AmountUnitChoice;
  category?: InputMaybe<Scalars['String']['input']>;
  cbkNet: Scalars['CustomDecimal']['input'];
  cbkSolid: Scalars['CustomDecimal']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  factorCbkNetCbkSolid?: InputMaybe<Scalars['CustomDecimal']['input']>;
  latitude: Scalars['CustomDecimal']['input'];
  location: Scalars['String']['input'];
  locationPlan?: InputMaybe<Scalars['String']['input']>;
  locationType: LocationTypeChoice;
  logLength: Scalars['CustomDecimal']['input'];
  longitude: Scalars['CustomDecimal']['input'];
  markedAsBroached?: InputMaybe<Scalars['Boolean']['input']>;
  mustBeAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  pileNumberFurnisher?: InputMaybe<Scalars['String']['input']>;
  plotNumber: Scalars['Int']['input'];
  qualityType: QualityTypeChoice;
  sort: Scalars['String']['input'];
  status: OldSystemStatusChoice;
  timber?: InputMaybe<Scalars['String']['input']>;
  type: PileTypeChoice;
  usageSort: UsageSortChoice;
  woodtype: Scalars['String']['input'];
  woodtype2?: InputMaybe<Scalars['String']['input']>;
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationCreatePlotArgs {
  category: CategoryTypeChoice;
  customer?: InputMaybe<Scalars['ID']['input']>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  mustBeRemovedSeparately?: InputMaybe<Scalars['Boolean']['input']>;
  number: Scalars['Int']['input'];
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationCreateWagonInventoryArgs {
  accuracy?: InputMaybe<Scalars['Decimal']['input']>;
  amount: Scalars['Float']['input'];
  count: Scalars['Int']['input'];
  inventoryDetails?: InputMaybe<Array<InputMaybe<InventoryDetailType>>>;
  isWagonReady: Scalars['Boolean']['input'];
  latitude?: InputMaybe<Scalars['Decimal']['input']>;
  loadEverything?: InputMaybe<Scalars['Boolean']['input']>;
  longitude?: InputMaybe<Scalars['Decimal']['input']>;
  order: Scalars['ID']['input'];
  time: Scalars['String']['input'];
  wagonNumber: Scalars['Int']['input'];
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationDeleteInventoryArgs {
  inventoryId: Scalars['ID']['input'];
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationDeletePileArgs {
  pileId: Scalars['ID']['input'];
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationDeletePilesFromExistingOrderArgs {
  orderId: Scalars['ID']['input'];
  pileIdList: Array<InputMaybe<Scalars['ID']['input']>>;
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationDeletePilesListArgs {
  pilesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationDeletePlotArgs {
  plotId: Scalars['ID']['input'];
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationDeleteTimesheetArgs {
  timesheet: Scalars['ID']['input'];
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationDownloadWagonInventoryArgs {
  deliveryStatusId: Scalars['ID']['input'];
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationEditAccountArgs {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  passwordRepeat?: InputMaybe<Scalars['String']['input']>;
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationEditInventoryArgs {
  accuracy?: InputMaybe<Scalars['Float']['input']>;
  amount: Scalars['Float']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
  inventoryDetails?: InputMaybe<Array<InputMaybe<InventoryDetailType>>>;
  inventoryId: Scalars['ID']['input'];
  isBroached: Scalars['Boolean']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  rest?: InputMaybe<Scalars['Int']['input']>;
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationEditInventoryTimeArgs {
  inventoryId: Scalars['ID']['input'];
  time: Scalars['String']['input'];
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationEditOrderArgs {
  amount?: InputMaybe<Scalars['Int']['input']>;
  customer: Scalars['ID']['input'];
  deliveryNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryStatus?: InputMaybe<Scalars['ID']['input']>;
  driver?: InputMaybe<Scalars['ID']['input']>;
  isPlausible?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  noteDriver?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['ID']['input'];
  piles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  planDate?: InputMaybe<Scalars['DateTime']['input']>;
  repeat?: InputMaybe<Scalars['Boolean']['input']>;
  repeatEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  routes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  supplier?: InputMaybe<Scalars['ID']['input']>;
  transportMedia?: InputMaybe<Scalars['ID']['input']>;
  vehicle?: InputMaybe<Scalars['ID']['input']>;
  weightFormNumber?: InputMaybe<Scalars['String']['input']>;
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationEditOrderDeliveryWeightFormNumberArgs {
  deliveryNumber?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
  weightFormNumber?: InputMaybe<Scalars['String']['input']>;
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationEditOrderIsPlausibleArgs {
  isPlausible: Scalars['Boolean']['input'];
  orderId: Scalars['ID']['input'];
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationEditTimesheetArgs {
  checkInDispatchedAt?: InputMaybe<Scalars['DateTime']['input']>;
  checkOutDispatchedAt?: InputMaybe<Scalars['DateTime']['input']>;
  timesheet: Scalars['ID']['input'];
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationExportPilesArgs {
  pilesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationImportPilesArgs {
  pilesFile: Scalars['Upload']['input'];
  plotNumber: Scalars['Int']['input'];
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationRefreshTokenArgs {
  token?: InputMaybe<Scalars['String']['input']>;
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationRollbackOrderStatusChangeArgs {
  orderId: Scalars['ID']['input'];
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationSetDeliveryNoteCustomerArgs {
  deliveryNoteCustomerId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationSetDeliveryNoteSupplierArgs {
  deliveryNoteSupplierId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationSetOrderStatusArgs {
  accuracy?: InputMaybe<Scalars['Decimal']['input']>;
  dispatchedAt?: InputMaybe<Scalars['DateTime']['input']>;
  idList: Array<InputMaybe<Scalars['ID']['input']>>;
  latitude?: InputMaybe<Scalars['Decimal']['input']>;
  longitude?: InputMaybe<Scalars['Decimal']['input']>;
  milage?: InputMaybe<Scalars['Int']['input']>;
  repeatOnFinished?: InputMaybe<Scalars['Boolean']['input']>;
  status: StatusChoice;
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationTokenAuthArgs {
  clientKey: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationUpdateMilageOnStatusChangeArgs {
  milage: Scalars['Int']['input'];
  statusChangeId: Scalars['ID']['input'];
}


/** This class will inherit from multiple Mutations as we begin to add more apps to our project. */
export interface MutationVerifyTokenArgs {
  token?: InputMaybe<Scalars['String']['input']>;
}

/** An object with an ID */
export interface Node {
  /** The ID of the object */
  id: Scalars['ID']['output'];
}

/** An enumeration. */
export enum OldSystemStatusChoice {
  Disposable = 'DISPOSABLE',
  Preplanning = 'PREPLANNING'
}

export interface OrderDeliveryNoteCustomerMutation {
  __typename?: 'OrderDeliveryNoteCustomerMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<OrderNode>;
}

export interface OrderDeliveryNoteSupplierMutation {
  __typename?: 'OrderDeliveryNoteSupplierMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<OrderNode>;
}

/** An enumeration. */
export enum OrderDeliveryType {
  /** Lieferung */
  Delivery = 'DELIVERY',
  /** Vorlieferung */
  Predelivery = 'PREDELIVERY'
}

/** This node provides information of order. */
export interface OrderNode extends Node {
  __typename?: 'OrderNode';
  /** @deprecated Will be removed */
  amount?: Maybe<Scalars['Int']['output']>;
  canBeAborted?: Maybe<Scalars['Boolean']['output']>;
  collectedFromOtherSystem: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<AccountNode>;
  customer: CompanyNode;
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  deliveryNoteCustomer?: Maybe<FileUploadNode>;
  deliveryNoteSupplier?: Maybe<FileUploadNode>;
  deliveryNumber?: Maybe<Scalars['String']['output']>;
  /** @deprecated Will be removed */
  deliveryStatus?: Maybe<DeprecatedDeliveryStatus>;
  deliveryType?: Maybe<OrderDeliveryType>;
  driver?: Maybe<AccountNode>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inventories: InventoryNodeConnection;
  inventorySummary?: Maybe<Array<Maybe<InventorySummaryNode>>>;
  isPlausible: Scalars['Boolean']['output'];
  lastmodifiedAt: Scalars['DateTime']['output'];
  lastmodifiedBy?: Maybe<AccountNode>;
  note?: Maybe<Scalars['String']['output']>;
  noteDriver?: Maybe<Scalars['String']['output']>;
  number: Scalars['Int']['output'];
  piles: PileNodeConnection;
  planDate?: Maybe<Scalars['DateTime']['output']>;
  repeat: Scalars['Boolean']['output'];
  repeatEndDate?: Maybe<Scalars['DateTime']['output']>;
  route: RouteNodeConnection;
  status?: Maybe<Scalars['String']['output']>;
  statusChanges?: Maybe<Array<Maybe<StatusChangeNode>>>;
  supplier?: Maybe<CompanyNode>;
  transportMedia?: Maybe<FileUploadNode>;
  type: OrderType;
  vehicle?: Maybe<VehicleNode>;
  weightFormNumber?: Maybe<Scalars['String']['output']>;
}


/** This node provides information of order. */
export interface OrderNodeInventoriesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['ID']['input']>;
}


/** This node provides information of order. */
export interface OrderNodePilesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category_Icontains?: InputMaybe<Scalars['String']['input']>;
  category_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  client_Name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  districtMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  district_Icontains?: InputMaybe<Scalars['String']['input']>;
  district_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeBroached?: InputMaybe<Scalars['Boolean']['input']>;
  isBroached?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location_Icontains?: InputMaybe<Scalars['String']['input']>;
  logLength?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logLengthMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logLength_Gte?: InputMaybe<Scalars['Decimal']['input']>;
  logLength_Lte?: InputMaybe<Scalars['Decimal']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  number_Contains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  plotId?: InputMaybe<Scalars['String']['input']>;
  plot_Company_Name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  plot_Company_Name_Multi?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  plot_Number?: InputMaybe<Scalars['Int']['input']>;
  plot_Number_Contains?: InputMaybe<Scalars['Int']['input']>;
  qualityType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort_Icontains?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  statusMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  usageSort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  woodtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  woodtypeMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  woodtype_Icontains?: InputMaybe<Scalars['String']['input']>;
}


/** This node provides information of order. */
export interface OrderNodeRouteArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['ID']['input']>;
}

export interface OrderNodeConnection {
  __typename?: 'OrderNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrderNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
}

/** A Relay edge containing a `OrderNode` and its cursor. */
export interface OrderNodeEdge {
  __typename?: 'OrderNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<OrderNode>;
}

export interface OrderStatusMutation {
  __typename?: 'OrderStatusMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
  orders?: Maybe<Array<Maybe<OrderNode>>>;
}

/** This node provides information about Status */
export interface OrderStatusNode extends Node {
  __typename?: 'OrderStatusNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
}

export interface OrderStatusNodeConnection {
  __typename?: 'OrderStatusNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrderStatusNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
}

/** A Relay edge containing a `OrderStatusNode` and its cursor. */
export interface OrderStatusNodeEdge {
  __typename?: 'OrderStatusNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<OrderStatusNode>;
}

/** An enumeration. */
export enum OrderType {
  /** ohne_polter */
  WithoutPile = 'WITHOUT_PILE',
  /** mit_polter */
  WithPile = 'WITH_PILE'
}

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export interface PageInfo {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
}

/** An enumeration. */
export enum PileAmountUnit {
  /** Tonne atro */
  Atr = 'ATR',
  /** Kubikmeter */
  Cbm = 'CBM',
  /** Kubikfuß */
  Cft = 'CFT',
  /** Festmeter ohne Rinde */
  Fmo = 'FMO',
  /** Laufmeter */
  Lfm = 'LFM',
  /** Tonne lutro */
  Lut = 'LUT',
  /** Raummeter mit Rinde */
  Rmm = 'RMM',
  /** Schüttraummeter */
  Srm = 'SRM',
  /** Stück */
  Stk = 'STK'
}

/** A node representing the location of a pile. */
export interface PileLocationNode extends Node {
  __typename?: 'PileLocationNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** The location name. */
  name?: Maybe<Scalars['String']['output']>;
}

export interface PileLocationNodeConnection {
  __typename?: 'PileLocationNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PileLocationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
}

/** A Relay edge containing a `PileLocationNode` and its cursor. */
export interface PileLocationNodeEdge {
  __typename?: 'PileLocationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PileLocationNode>;
}

/** An enumeration. */
export enum PileLocationType {
  /** Werk */
  Factory = 'FACTORY',
  /** Waldlager */
  Forest = 'FOREST',
  /** Hafen */
  Harbor = 'HARBOR',
  /** Polter */
  Pile = 'PILE',
  /** Schiff */
  Ship = 'SHIP',
  /** Bahnhof */
  Station = 'STATION',
  /** Waggon */
  Wagon = 'WAGON'
}

/** This node provides information of users. */
export interface PileNode extends Node {
  __typename?: 'PileNode';
  amountUnit: PileAmountUnit;
  canBeAddedToAnyOrder?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  cbkNet: Scalars['Decimal']['output'];
  cbkNetActual: Scalars['Decimal']['output'];
  cbkSolid: Scalars['Decimal']['output'];
  cbkSolidActual: Scalars['Decimal']['output'];
  client?: Maybe<ClientNode>;
  count: Scalars['Int']['output'];
  countActual: Scalars['Int']['output'];
  cubikActual: Scalars['Decimal']['output'];
  cubikSolidActual: Scalars['Decimal']['output'];
  date?: Maybe<Scalars['Date']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  factorCbkNetCbkSolid: Scalars['Decimal']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inventories?: Maybe<Array<Maybe<InventoryNode>>>;
  isBroached: Scalars['Boolean']['output'];
  latitude: Scalars['Decimal']['output'];
  location: Scalars['String']['output'];
  locationPlan: Scalars['String']['output'];
  locationType: PileLocationType;
  logLength: Scalars['Decimal']['output'];
  longitude: Scalars['Decimal']['output'];
  markedAsBroached: Scalars['Boolean']['output'];
  mustBeAccepted: Scalars['Boolean']['output'];
  note: Scalars['String']['output'];
  number: Scalars['String']['output'];
  oldSystemCount: Scalars['Int']['output'];
  pileNumberFurnisher: Scalars['String']['output'];
  pkOtherSystem?: Maybe<Scalars['String']['output']>;
  plot?: Maybe<PlotNode>;
  qualityType: PileQualityType;
  rest: Scalars['Decimal']['output'];
  sort: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  statusOldSystem: PileStatusOldSystem;
  timber?: Maybe<Scalars['String']['output']>;
  type: PileType;
  usageSort: PileUsageSort;
  woodtype: Scalars['String']['output'];
  woodtype2: Scalars['String']['output'];
}

export interface PileNodeConnection {
  __typename?: 'PileNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PileNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
}

/** A Relay edge containing a `PileNode` and its cursor. */
export interface PileNodeEdge {
  __typename?: 'PileNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PileNode>;
}

/** An enumeration. */
export enum PileQualityType {
  /** A */
  A = 'A',
  /** AK */
  Ak = 'AK',
  /** A_BH */
  ABh = 'A_BH',
  /** A_FU */
  AFu = 'A_FU',
  /** A_I2 */
  AI2 = 'A_I2',
  /** A_ID */
  AId = 'A_ID',
  /** A_IF */
  AIf = 'A_IF',
  /** A_IM */
  AIm = 'A_IM',
  /** A_IS */
  AIs = 'A_IS',
  /** A_SP */
  ASp = 'A_SP',
  /** A_X */
  AX = 'A_X',
  /** A_Y */
  AY = 'A_Y',
  /** A_Z */
  AZ = 'A_Z',
  /** B */
  B = 'B',
  /** BC */
  Bc = 'BC',
  /** BCD */
  Bcd = 'BCD',
  /** BK */
  Bk = 'BK',
  /** C */
  C = 'C',
  /** CD */
  Cd = 'CD',
  /** CH_1 */
  Ch_1 = 'CH_1',
  /** CH_2 */
  Ch_2 = 'CH_2',
  /** CH_AB */
  ChAb = 'CH_AB',
  /** CH_ABC */
  ChAbc = 'CH_ABC',
  /** CH_BC */
  ChBc = 'CH_BC',
  /** CH_BK */
  ChBk = 'CH_BK',
  /** CH_CD */
  ChCd = 'CH_CD',
  /** CH_K */
  ChK = 'CH_K',
  /** CH_R */
  ChR = 'CH_R',
  /** CH_SK */
  ChSk = 'CH_SK',
  /** D */
  D = 'D',
  /** FK */
  Fk = 'FK',
  /** IF */
  If = 'IF',
  /** IK */
  Ik = 'IK',
  /** IN */
  In = 'IN',
  /** NF */
  Nf = 'NF',
  /** NFK */
  Nfk = 'NFK',
  /** O */
  O = 'O',
  /** OA */
  Oa = 'OA'
}

/** An enumeration. */
export enum PileStatusOldSystem {
  /** Disponierbar */
  Disposable = 'DISPOSABLE',
  /** Vorplanung */
  PrePlanning = 'PRE_PLANNING'
}

/** An enumeration. */
export enum PileType {
  /** Einzelstamm */
  Log = 'LOG',
  /** Polter */
  Pile = 'PILE'
}

/** An enumeration. */
export enum PileTypeChoice {
  Log = 'LOG',
  Pile = 'PILE'
}

/** An enumeration. */
export enum PileUsageSort {
  /** AU */
  Au = 'AU',
  /** CB */
  Cb = 'CB',
  /** CH_BRHK */
  ChBrhk = 'CH_BRHK',
  /** CH_BRHL */
  ChBrhl = 'CH_BRHL',
  /** CH_H */
  ChH = 'CH_H',
  /** CH_HHAP */
  ChHhap = 'CH_HHAP',
  /** CH_HHEB */
  ChHheb = 'CH_HHEB',
  /** CH_HS */
  ChHs = 'CH_HS',
  /** CH_KBU */
  ChKbu = 'CH_KBU',
  /** CH_KSP */
  ChKsp = 'CH_KSP',
  /** CH_KST */
  ChKst = 'CH_KST',
  /** CH_LANG */
  ChLang = 'CH_LANG',
  /** CH_P */
  ChP = 'CH_P',
  /** CH_RU */
  ChRu = 'CH_RU',
  /** CH_SP */
  ChSp = 'CH_SP',
  /** CH_SW */
  ChSw = 'CH_SW',
  /** CH_Z */
  ChZ = 'CH_Z',
  /** EH */
  Eh = 'EH',
  /** F */
  F = 'F',
  /** GL */
  Gl = 'GL',
  /** HS */
  Hs = 'HS',
  /** IH */
  Ih = 'IH',
  /** LA */
  La = 'LA',
  /** M */
  M = 'M',
  /** MDF */
  Mdf = 'MDF',
  /** NL */
  Nl = 'NL',
  /** NS */
  Ns = 'NS',
  /** OSB */
  Osb = 'OSB',
  /** OV */
  Ov = 'OV',
  /** P */
  P = 'P',
  /** PA */
  Pa = 'PA',
  /** PH */
  Ph = 'PH',
  /** PK */
  Pk = 'PK',
  /** PZ */
  Pz = 'PZ',
  /** R */
  R = 'R',
  /** RH */
  Rh = 'RH',
  /** RU */
  Ru = 'RU',
  /** SB */
  Sb = 'SB',
  /** SF */
  Sf = 'SF',
  /** SG */
  Sg = 'SG',
  /** SL */
  Sl = 'SL',
  /** SS */
  Ss = 'SS',
  /** ST */
  St = 'ST',
  /** SW */
  Sw = 'SW',
  /** TF */
  Tf = 'TF',
  /** VB */
  Vb = 'VB',
  /** WH */
  Wh = 'WH',
  /** XY */
  Xy = 'XY'
}

/** An enumeration. */
export enum PlotCategory {
  /** Zukauf */
  Purchase = 'PURCHASE',
  /** Transport */
  Transport = 'TRANSPORT'
}

/** This node provides information of users. */
export interface PlotNode extends Node {
  __typename?: 'PlotNode';
  category?: Maybe<PlotCategory>;
  company?: Maybe<CompanyNode>;
  done: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  mustBeRemovedSeparately: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  numberOfBroachedPiles?: Maybe<Scalars['Int']['output']>;
  numberOfPiles?: Maybe<Scalars['Int']['output']>;
  pkOtherSystem?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  strSelection?: Maybe<Scalars['String']['output']>;
  sumCbkNet?: Maybe<Scalars['Float']['output']>;
  sumCbkSolid?: Maybe<Scalars['Float']['output']>;
  sumCount?: Maybe<Scalars['Float']['output']>;
  sumCountActual?: Maybe<Scalars['Float']['output']>;
  sumCubikActual?: Maybe<Scalars['Float']['output']>;
  sumCubikSolidActual?: Maybe<Scalars['Float']['output']>;
}

export interface PlotNodeConnection {
  __typename?: 'PlotNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PlotNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
}

/** A Relay edge containing a `PlotNode` and its cursor. */
export interface PlotNodeEdge {
  __typename?: 'PlotNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PlotNode>;
}

/** This node provides information about Status */
export interface PlotStatusNode extends Node {
  __typename?: 'PlotStatusNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
}

export interface PlotStatusNodeConnection {
  __typename?: 'PlotStatusNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PlotStatusNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
}

/** A Relay edge containing a `PlotStatusNode` and its cursor. */
export interface PlotStatusNodeEdge {
  __typename?: 'PlotStatusNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PlotStatusNode>;
}

/** An enumeration. */
export enum QualityTypeChoice {
  A = 'A',
  Ak = 'AK',
  ABh = 'A_BH',
  AFu = 'A_FU',
  AI2 = 'A_I2',
  AId = 'A_ID',
  AIf = 'A_IF',
  AIm = 'A_IM',
  AIs = 'A_IS',
  ASp = 'A_SP',
  AX = 'A_X',
  AY = 'A_Y',
  AZ = 'A_Z',
  B = 'B',
  Bc = 'BC',
  Bcd = 'BCD',
  Bk = 'BK',
  C = 'C',
  Cd = 'CD',
  Ch_1 = 'CH_1',
  Ch_2 = 'CH_2',
  ChAb = 'CH_AB',
  ChAbc = 'CH_ABC',
  ChBc = 'CH_BC',
  ChBk = 'CH_BK',
  ChCd = 'CH_CD',
  ChK = 'CH_K',
  ChR = 'CH_R',
  ChSk = 'CH_SK',
  D = 'D',
  Fk = 'FK',
  If = 'IF',
  Ik = 'IK',
  In = 'IN',
  Nf = 'NF',
  Nfk = 'NFK',
  O = 'O',
  Oa = 'OA'
}

/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface Query {
  __typename?: 'Query';
  account?: Maybe<AccountNode>;
  accounts?: Maybe<AccountNodeConnection>;
  companies?: Maybe<CompanyNodeConnection>;
  company?: Maybe<CompanyNode>;
  companyLocations?: Maybe<CompanyLocationNodeConnection>;
  emails?: Maybe<StringPaginationType>;
  firstNames?: Maybe<StringPaginationType>;
  groups?: Maybe<GroupNodeConnection>;
  inventories?: Maybe<InventoryNodeConnection>;
  inventoriesByDeliveryStatusTowardsWagon?: Maybe<Array<Maybe<InventoriesByDeliveryStatusNode>>>;
  inventoryPlanings?: Maybe<InventoryPlaningNodeConnection>;
  lastNames?: Maybe<StringPaginationType>;
  logLengths?: Maybe<StringPaginationType>;
  me?: Maybe<AccountNode>;
  order?: Maybe<OrderNode>;
  orderStatus?: Maybe<OrderStatusNodeConnection>;
  orderTypes?: Maybe<OrderNodeConnection>;
  orders?: Maybe<OrderNodeConnection>;
  pile?: Maybe<PileNode>;
  pileCategories?: Maybe<PileNodeConnection>;
  pileClients?: Maybe<StringPaginationType>;
  pileDistricts?: Maybe<PileNodeConnection>;
  pileLocations?: Maybe<PileLocationNodeConnection>;
  pileSorts?: Maybe<PileNodeConnection>;
  pileStatus?: Maybe<PileNodeConnection>;
  pileTypes?: Maybe<PileNodeConnection>;
  piles?: Maybe<PileNodeConnection>;
  pilesNoLimit?: Maybe<PileNodeConnection>;
  plot?: Maybe<PlotNode>;
  plotStatus?: Maybe<PlotStatusNodeConnection>;
  plots?: Maybe<PlotNodeConnection>;
  prefetchOrders?: Maybe<OrderNodeConnection>;
  qualityTypes?: Maybe<StringPaginationType>;
  routes?: Maybe<RouteNodeConnection>;
  supplier?: Maybe<StringPaginationType>;
  timbers?: Maybe<StringPaginationType>;
  timeSheets?: Maybe<TimeSheetNodeConnection>;
  times?: Maybe<TimeNodeConnection>;
  usageSorts?: Maybe<StringPaginationType>;
  vehicles?: Maybe<VehicleNodeConnection>;
  woodtypes?: Maybe<PileNodeConnection>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryAccountArgs {
  accountId?: InputMaybe<Scalars['ID']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryAccountsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryCompaniesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['Boolean']['input']>;
  supplier_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryCompanyArgs {
  companyId?: InputMaybe<Scalars['ID']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryCompanyLocationsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  company_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fullAddress?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryEmailsArgs {
  filterMultipleValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filterValue?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryFirstNamesArgs {
  filterMultipleValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filterValue?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryGroupsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Contains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryInventoriesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['ID']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryInventoriesByDeliveryStatusTowardsWagonArgs {
  deliveryStatusId?: InputMaybe<Scalars['ID']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryInventoryPlaningsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['ID']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryLastNamesArgs {
  filterMultipleValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filterValue?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryLogLengthsArgs {
  filterMultipleValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filterValue?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryOrderArgs {
  orderId?: InputMaybe<Scalars['ID']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryOrderStatusArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryOrderTypesArgs {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  addablePiles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  collectedFromOtherSystem?: InputMaybe<Scalars['Boolean']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  driver?: InputMaybe<Scalars['ID']['input']>;
  driver_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isPlausible?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  number_Contains?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderByActiveStatus?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['ID']['input']>;
  supplier_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  usesPiles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  vehicle?: InputMaybe<Scalars['ID']['input']>;
  vehicle_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryOrdersArgs {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  addablePiles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  collectedFromOtherSystem?: InputMaybe<Scalars['Boolean']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  driver?: InputMaybe<Scalars['ID']['input']>;
  driver_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isPlausible?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  number_Contains?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderByActiveStatus?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['ID']['input']>;
  supplier_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  usesPiles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  vehicle?: InputMaybe<Scalars['ID']['input']>;
  vehicle_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryPileArgs {
  pileId?: InputMaybe<Scalars['ID']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryPileCategoriesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category_Icontains?: InputMaybe<Scalars['String']['input']>;
  category_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  client_Name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  districtMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  district_Icontains?: InputMaybe<Scalars['String']['input']>;
  district_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeBroached?: InputMaybe<Scalars['Boolean']['input']>;
  isBroached?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location_Icontains?: InputMaybe<Scalars['String']['input']>;
  logLength?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logLengthMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logLength_Gte?: InputMaybe<Scalars['Decimal']['input']>;
  logLength_Lte?: InputMaybe<Scalars['Decimal']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  number_Contains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  plotId?: InputMaybe<Scalars['String']['input']>;
  plot_Company_Name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  plot_Company_Name_Multi?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  plot_Number?: InputMaybe<Scalars['Int']['input']>;
  plot_Number_Contains?: InputMaybe<Scalars['Int']['input']>;
  qualityType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort_Icontains?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  statusMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  usageSort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  woodtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  woodtypeMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  woodtype_Icontains?: InputMaybe<Scalars['String']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryPileClientsArgs {
  filterMultipleValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filterValue?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryPileDistrictsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category_Icontains?: InputMaybe<Scalars['String']['input']>;
  category_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  client_Name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  districtMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  district_Icontains?: InputMaybe<Scalars['String']['input']>;
  district_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeBroached?: InputMaybe<Scalars['Boolean']['input']>;
  isBroached?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location_Icontains?: InputMaybe<Scalars['String']['input']>;
  logLength?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logLengthMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logLength_Gte?: InputMaybe<Scalars['Decimal']['input']>;
  logLength_Lte?: InputMaybe<Scalars['Decimal']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  number_Contains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  plotId?: InputMaybe<Scalars['String']['input']>;
  plot_Company_Name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  plot_Company_Name_Multi?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  plot_Number?: InputMaybe<Scalars['Int']['input']>;
  plot_Number_Contains?: InputMaybe<Scalars['Int']['input']>;
  qualityType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort_Icontains?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  statusMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  usageSort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  woodtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  woodtypeMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  woodtype_Icontains?: InputMaybe<Scalars['String']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryPileLocationsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryPileSortsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category_Icontains?: InputMaybe<Scalars['String']['input']>;
  category_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  client_Name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  districtMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  district_Icontains?: InputMaybe<Scalars['String']['input']>;
  district_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeBroached?: InputMaybe<Scalars['Boolean']['input']>;
  isBroached?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location_Icontains?: InputMaybe<Scalars['String']['input']>;
  logLength?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logLengthMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logLength_Gte?: InputMaybe<Scalars['Decimal']['input']>;
  logLength_Lte?: InputMaybe<Scalars['Decimal']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  number_Contains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  plotId?: InputMaybe<Scalars['String']['input']>;
  plot_Company_Name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  plot_Company_Name_Multi?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  plot_Number?: InputMaybe<Scalars['Int']['input']>;
  plot_Number_Contains?: InputMaybe<Scalars['Int']['input']>;
  qualityType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort_Icontains?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  statusMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  usageSort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  woodtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  woodtypeMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  woodtype_Icontains?: InputMaybe<Scalars['String']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryPileStatusArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category_Icontains?: InputMaybe<Scalars['String']['input']>;
  category_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  client_Name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  districtMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  district_Icontains?: InputMaybe<Scalars['String']['input']>;
  district_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeBroached?: InputMaybe<Scalars['Boolean']['input']>;
  isBroached?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location_Icontains?: InputMaybe<Scalars['String']['input']>;
  logLength?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logLengthMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logLength_Gte?: InputMaybe<Scalars['Decimal']['input']>;
  logLength_Lte?: InputMaybe<Scalars['Decimal']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  number_Contains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  plotId?: InputMaybe<Scalars['String']['input']>;
  plot_Company_Name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  plot_Company_Name_Multi?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  plot_Number?: InputMaybe<Scalars['Int']['input']>;
  plot_Number_Contains?: InputMaybe<Scalars['Int']['input']>;
  qualityType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort_Icontains?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  statusMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  usageSort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  woodtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  woodtypeMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  woodtype_Icontains?: InputMaybe<Scalars['String']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryPileTypesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category_Icontains?: InputMaybe<Scalars['String']['input']>;
  category_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  client_Name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  districtMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  district_Icontains?: InputMaybe<Scalars['String']['input']>;
  district_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeBroached?: InputMaybe<Scalars['Boolean']['input']>;
  isBroached?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location_Icontains?: InputMaybe<Scalars['String']['input']>;
  logLength?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logLengthMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logLength_Gte?: InputMaybe<Scalars['Decimal']['input']>;
  logLength_Lte?: InputMaybe<Scalars['Decimal']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  number_Contains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  plotId?: InputMaybe<Scalars['String']['input']>;
  plot_Company_Name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  plot_Company_Name_Multi?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  plot_Number?: InputMaybe<Scalars['Int']['input']>;
  plot_Number_Contains?: InputMaybe<Scalars['Int']['input']>;
  qualityType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort_Icontains?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  statusMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  usageSort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  woodtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  woodtypeMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  woodtype_Icontains?: InputMaybe<Scalars['String']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryPilesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category_Icontains?: InputMaybe<Scalars['String']['input']>;
  category_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  client_Name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  districtMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  district_Icontains?: InputMaybe<Scalars['String']['input']>;
  district_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeBroached?: InputMaybe<Scalars['Boolean']['input']>;
  isBroached?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location_Icontains?: InputMaybe<Scalars['String']['input']>;
  logLength?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logLengthMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logLength_Gte?: InputMaybe<Scalars['Decimal']['input']>;
  logLength_Lte?: InputMaybe<Scalars['Decimal']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  number_Contains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  plotId?: InputMaybe<Scalars['String']['input']>;
  plot_Company_Name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  plot_Company_Name_Multi?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  plot_Number?: InputMaybe<Scalars['Int']['input']>;
  plot_Number_Contains?: InputMaybe<Scalars['Int']['input']>;
  qualityType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort_Icontains?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  statusMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  usageSort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  woodtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  woodtypeMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  woodtype_Icontains?: InputMaybe<Scalars['String']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryPilesNoLimitArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category_Icontains?: InputMaybe<Scalars['String']['input']>;
  category_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  client_Name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  districtMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  district_Icontains?: InputMaybe<Scalars['String']['input']>;
  district_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeBroached?: InputMaybe<Scalars['Boolean']['input']>;
  isBroached?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location_Icontains?: InputMaybe<Scalars['String']['input']>;
  logLength?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logLengthMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logLength_Gte?: InputMaybe<Scalars['Decimal']['input']>;
  logLength_Lte?: InputMaybe<Scalars['Decimal']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  number_Contains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  plotId?: InputMaybe<Scalars['String']['input']>;
  plot_Company_Name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  plot_Company_Name_Multi?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  plot_Number?: InputMaybe<Scalars['Int']['input']>;
  plot_Number_Contains?: InputMaybe<Scalars['Int']['input']>;
  qualityType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort_Icontains?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  statusMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  usageSort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  woodtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  woodtypeMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  woodtype_Icontains?: InputMaybe<Scalars['String']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryPlotArgs {
  plotId: Scalars['ID']['input'];
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryPlotStatusArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryPlotsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeAllStatus?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  number_Contains?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selection?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryPrefetchOrdersArgs {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  addablePiles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  collectedFromOtherSystem?: InputMaybe<Scalars['Boolean']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  driver?: InputMaybe<Scalars['ID']['input']>;
  driver_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isPlausible?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  number_Contains?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderByActiveStatus?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['ID']['input']>;
  supplier_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  usesPiles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  vehicle?: InputMaybe<Scalars['ID']['input']>;
  vehicle_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryQualityTypesArgs {
  filterMultipleValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filterValue?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryRoutesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['ID']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QuerySupplierArgs {
  filterMultipleValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filterValue?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryTimbersArgs {
  filterMultipleValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filterValue?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryTimeSheetsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryTimesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['ID']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryUsageSortsArgs {
  filterMultipleValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filterValue?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryVehiclesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}


/** This class will inherit from multiple Queries as we begin to add more apps to our project. */
export interface QueryWoodtypesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category_Icontains?: InputMaybe<Scalars['String']['input']>;
  category_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  client_Name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  districtMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  district_Icontains?: InputMaybe<Scalars['String']['input']>;
  district_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeBroached?: InputMaybe<Scalars['Boolean']['input']>;
  isBroached?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location_Icontains?: InputMaybe<Scalars['String']['input']>;
  logLength?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logLengthMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logLength_Gte?: InputMaybe<Scalars['Decimal']['input']>;
  logLength_Lte?: InputMaybe<Scalars['Decimal']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  number_Contains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  plotId?: InputMaybe<Scalars['String']['input']>;
  plot_Company_Name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  plot_Company_Name_Multi?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  plot_Number?: InputMaybe<Scalars['Int']['input']>;
  plot_Number_Contains?: InputMaybe<Scalars['Int']['input']>;
  qualityType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort_Icontains?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  statusMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  usageSort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  woodtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  woodtypeMulti?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  woodtype_Icontains?: InputMaybe<Scalars['String']['input']>;
}

export interface Refresh {
  __typename?: 'Refresh';
  payload: Scalars['GenericScalar']['output'];
  refreshExpiresIn: Scalars['Int']['output'];
  token: Scalars['String']['output'];
}

export interface RollbackOrderStatusChange {
  __typename?: 'RollbackOrderStatusChange';
  order?: Maybe<OrderNode>;
}

export interface RouteMutation {
  __typename?: 'RouteMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
}

export interface RouteNode extends Node {
  __typename?: 'RouteNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  latitude: Scalars['Decimal']['output'];
  longitude: Scalars['Decimal']['output'];
}

export interface RouteNodeConnection {
  __typename?: 'RouteNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RouteNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
}

/** A Relay edge containing a `RouteNode` and its cursor. */
export interface RouteNodeEdge {
  __typename?: 'RouteNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RouteNode>;
}

export interface RouteNodeInput {
  index: Scalars['Int']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
}

/** An enumeration. */
export enum StatusChangeNewStatus {
  /** abgebrochen */
  Aborted = 'ABORTED',
  /** zugewiesen */
  Allocated = 'ALLOCATED',
  /** begonnen */
  Commenced = 'COMMENCED',
  /** erstellt */
  Created = 'CREATED',
  /** übergeben */
  Delivered = 'DELIVERED',
  /** beendet */
  Finished = 'FINISHED',
  /** geladen */
  Loaded = 'LOADED',
  /** übermittelt */
  Transmitted = 'TRANSMITTED'
}

export interface StatusChangeNode extends Node {
  __typename?: 'StatusChangeNode';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<AccountNode>;
  dispatchedAt: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastmodifiedAt: Scalars['DateTime']['output'];
  lastmodifiedBy?: Maybe<AccountNode>;
  milage?: Maybe<Scalars['Int']['output']>;
  newStatus: StatusChangeNewStatus;
  oldStatus?: Maybe<StatusChangeOldStatus>;
  order: OrderStatusNode;
}

/** An enumeration. */
export enum StatusChangeOldStatus {
  /** abgebrochen */
  Aborted = 'ABORTED',
  /** zugewiesen */
  Allocated = 'ALLOCATED',
  /** begonnen */
  Commenced = 'COMMENCED',
  /** erstellt */
  Created = 'CREATED',
  /** übergeben */
  Delivered = 'DELIVERED',
  /** beendet */
  Finished = 'FINISHED',
  /** geladen */
  Loaded = 'LOADED',
  /** übermittelt */
  Transmitted = 'TRANSMITTED'
}

/** An enumeration. */
export enum StatusChoice {
  Aborted = 'ABORTED',
  Allocated = 'ALLOCATED',
  Commenced = 'COMMENCED',
  Created = 'CREATED',
  Delivered = 'DELIVERED',
  Finished = 'FINISHED',
  Loaded = 'LOADED',
  Transmitted = 'TRANSMITTED'
}

/**
 * This type holds the information for a pagination of strings.
 *
 * page = current page
 * pages = total number of pages
 * has_next = is there a next page?
 * has_previous = is there a previous page?
 * strings = list of strings; this is the data
 */
export interface StringPaginationType {
  __typename?: 'StringPaginationType';
  hasNext?: Maybe<Scalars['Boolean']['output']>;
  hasPrevious?: Maybe<Scalars['Boolean']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  pages?: Maybe<Scalars['Int']['output']>;
  strings?: Maybe<Array<Scalars['String']['output']>>;
}

/** This node provides information about Time */
export interface TimeNode extends Node {
  __typename?: 'TimeNode';
  begin: Scalars['DateTime']['output'];
  end: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  kmBegin?: Maybe<Scalars['Int']['output']>;
  kmEnd?: Maybe<Scalars['Int']['output']>;
  order: OrderStatusNode;
  user: AccountNode;
  vehicle?: Maybe<VehicleNode>;
}

export interface TimeNodeConnection {
  __typename?: 'TimeNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TimeNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
}

/** A Relay edge containing a `TimeNode` and its cursor. */
export interface TimeNodeEdge {
  __typename?: 'TimeNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TimeNode>;
}

/** This node provides information on the timesheets of a user */
export interface TimeSheetNode extends Node {
  __typename?: 'TimeSheetNode';
  checkInCreatedAt: Scalars['DateTime']['output'];
  checkInDispatchedAt: Scalars['DateTime']['output'];
  checkOutCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  checkOutDispatchedAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<AccountNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastmodifiedBy?: Maybe<AccountNode>;
  user?: Maybe<AccountNode>;
}

export interface TimeSheetNodeConnection {
  __typename?: 'TimeSheetNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TimeSheetNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
}

/** A Relay edge containing a `TimeSheetNode` and its cursor. */
export interface TimeSheetNodeEdge {
  __typename?: 'TimeSheetNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TimeSheetNode>;
}

export interface UpdateMilageOnStatusChange {
  __typename?: 'UpdateMilageOnStatusChange';
  ok?: Maybe<Scalars['Boolean']['output']>;
  statusChange?: Maybe<StatusChangeNode>;
  vehicleMilageChanged?: Maybe<Scalars['Boolean']['output']>;
}

export interface UploadPilesMutation {
  __typename?: 'UploadPilesMutation';
  count?: Maybe<Scalars['Int']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
}

/** An enumeration. */
export enum UsageSortChoice {
  Au = 'AU',
  Cb = 'CB',
  ChBrhk = 'CH_BRHK',
  ChBrhl = 'CH_BRHL',
  ChH = 'CH_H',
  ChHhap = 'CH_HHAP',
  ChHheb = 'CH_HHEB',
  ChHs = 'CH_HS',
  ChKbu = 'CH_KBU',
  ChKsp = 'CH_KSP',
  ChKst = 'CH_KST',
  ChLang = 'CH_LANG',
  ChP = 'CH_P',
  ChRu = 'CH_RU',
  ChSp = 'CH_SP',
  ChSw = 'CH_SW',
  ChZ = 'CH_Z',
  Eh = 'EH',
  F = 'F',
  Gl = 'GL',
  Hs = 'HS',
  Ih = 'IH',
  La = 'LA',
  M = 'M',
  Mdf = 'MDF',
  Nl = 'NL',
  Ns = 'NS',
  Osb = 'OSB',
  Ov = 'OV',
  P = 'P',
  Pa = 'PA',
  Ph = 'PH',
  Pk = 'PK',
  Pz = 'PZ',
  R = 'R',
  Rh = 'RH',
  Ru = 'RU',
  Sb = 'SB',
  Sf = 'SF',
  Sg = 'SG',
  Sl = 'SL',
  Ss = 'SS',
  St = 'ST',
  Sw = 'SW',
  Tf = 'TF',
  Vp = 'VP',
  Wh = 'WH',
  Xy = 'XY'
}

/** This node provides information of vehicles. */
export interface VehicleNode extends Node {
  __typename?: 'VehicleNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  milage: Scalars['Int']['output'];
  registrationNumber: Scalars['String']['output'];
}

export interface VehicleNodeConnection {
  __typename?: 'VehicleNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VehicleNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
}

/** A Relay edge containing a `VehicleNode` and its cursor. */
export interface VehicleNodeEdge {
  __typename?: 'VehicleNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<VehicleNode>;
}

export interface Verify {
  __typename?: 'Verify';
  payload: Scalars['GenericScalar']['output'];
}
